module.exports = __webpack_public_path__ + "static/media/quote-right-single.21a8c8fe.svg";